import { createFileRoute } from '@tanstack/react-router';
import { ShipmentsGroupDetailLayout } from '@uturn/portal/modules/shipments';
import z from 'zod';

const ShipmentsGroupsGroupIdParams = z.object({
	groupId: z.coerce.number(),
});

export const Route = createFileRoute(
	'/_protected/shipments/groups/$groupId',
)({
	params: {
		parse: (rawParams) => ShipmentsGroupsGroupIdParams.parse(rawParams),
	},
	component: ShipmentsGroupDetailLayout,
});
